import { useEffect } from "react";
import { pingDesktop } from "../lib/pushClient";
import { isDesktop } from "./useInstallPrompt";
import { Capacitor } from "@capacitor/core";

const PING_INTERVAL_MS = 60 * 1000;

export const useDesktopPing = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return;
    // A native (iOS/Android) app device must NEVER mark itself "desktop-active"
    // — it receives native push instead. Without this guard a pointer:fine
    // native device (e.g. iPad + trackpad) would ping the heartbeat and could
    // cause a double-notify alongside an open desktop tab.
    if (Capacitor.isNativePlatform()) return;
    // Ping from any desktop device (installed PWA or browser tab) so a DJ
    // with the dashboard open during a set is treated as "reachable by push".
    if (!isDesktop()) return;

    let cancelled = false;

    const ping = () => {
      if (cancelled) return;
      if (document.visibilityState === "visible") {
        pingDesktop();
      }
    };

    ping();
    const interval = window.setInterval(ping, PING_INTERVAL_MS);

    const onVisibility = () => {
      if (document.visibilityState === "visible") ping();
    };
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      cancelled = true;
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [enabled]);
};
